import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const RectangleHorizontal: IconNode = [
  'svg',
  defaultAttributes,
  [['rect', { width: '20', height: '12', x: '2', y: '6', rx: '2' }]],
];

export default RectangleHorizontal;
